import { GX_API_URL } from '@/constants/env';
import { exportPreviewApi } from '@/features/DataHub/api/exportPreview.api';
import type { PastExportDetails } from '@/features/DataHub/api/pastExports.api';
import { templatesApi } from '@/features/DataHub/api/templates.api';
import { buildExportApiRequestString } from '@/features/DataHub/modules/Export/services/ExportRequestService';
import type { PreviewGenerationContext } from '@/features/DataHub/modules/Export/services/PreviewService.types';
import { pythonPreviewService } from '@/features/DataHub/modules/Export/services/PythonPreviewService';
import { downloadAsFile } from '@/features/DataHub/modules/Export/utils/downloadFileUtils';

/** Export types where regeneration fetches data client-side (server only returns downloadUrl for Excel) */
export const CLIENT_SIDE_DOWNLOAD_TYPES = new Set(['csv', 'curl', 'python', 'gx_api']);

export const performClientSideDownload = async (
  effectiveType: string,
  data: PastExportDetails,
  apiKey: string
): Promise<void> => {
  if (effectiveType === 'gx_api') {
    const apiUrl = buildExportApiRequestString({
      gxURL: GX_API_URL,
      symbols: data.symbols,
      fromValue: data.from,
      toValue: data.to || null,
      includeMetadata: data.metadata === 'true',
      userTimezone: data.timezone
    });
    window.open(apiUrl, '_blank', 'noopener,noreferrer');
  } else if (effectiveType === 'python') {
    const template = await templatesApi.fetchPythonTemplate();
    const context: PreviewGenerationContext = {
      symbols: data.symbols,
      rangeStart: data.from || 'all',
      rangeEnd: data.to || '',
      timezone: data.timezone,
      includeMetadata: data.metadata === 'true',
      apiKey,
      gxURL: ''
    };
    const result = pythonPreviewService.generateFromTemplate(template, context);
    downloadAsFile(result.content, 'python');
  } else {
    const isCSV = effectiveType === 'csv';
    const content = await exportPreviewApi.fetchPreviewList(
      {
        from: data.from,
        to: data.to || null,
        includeMetadata: data.metadata === 'true',
        isCSV,
        userTimezone: data.timezone
      },
      data.symbols,
      isCSV ? { Accept: 'text/csv' } : undefined
    );
    downloadAsFile(content, isCSV ? 'csv' : 'json');
  }
};
